import React from 'react';
import { copy } from '../data/noklar';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-130" data-mp="3gf92wqh5nw6b">
      <div className="mx-auto max-w-6xl" data-id="element-131" data-mp="3ghc2o28413o8">
        <p className="font-serif text-3xl tracking-tight" data-id="element-132" data-mp="32oe1fz8zkhcr">
          {copy.footer.brand}<span className="align-super text-[0.5em]" data-id="element-133" data-mp="36pfufycb7x6a">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-134" data-mp="36nd4tff2k623">
          {copy.footer.disclaimer}
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-135" data-mp="38qtcrvhxfo0">
          {copy.footer.copyright}
        </p>
      </div>
    </footer>;
}